import { formatBool } from '@/utils/shared';
import { presentNumberToCurrencyTable } from '@/services/formatter_services/currency-formatter';
import dateFormatter from "@/services/formatter_services/date-formatter";
import i18n from '@/language/i18n';
import TRUNCATE_UNITS from '@/utils/enum/TRUNCATE_UNITS';
import dateService from '@/services/date-service';
import store from '@/store';
import { noHtmlTagsFormat } from '@/services/format-service';
//enum
import FORMAT_EXCEL_EXPORT_TYPE_ENUM from '@/services/formatter_services/enums/FORMAT_EXCEL_EXPORT_TYPE_ENUM'
import TASK_STATUS_TYPES from '@/modules/process_support/tasks/enums/TASK_STATUS_TYPES';

const FIRST_DAY_OF_CURRENT_YEAR = dateService.getFirstDayOfMonth(new Date().getFullYear(), 0);
const LAST_DAY_OF_CURRENT_YEAR = dateService.getLastDayOfMonth(new Date().getFullYear(), 11)

const TASK_TABLE_HEADERS = [
  // {
  //   text: 'Common.status', value: 'status',
  //   presentWith: (value) => TASK_STATUS_TYPES.find((type) => type.id === value)?.text,
  // },
  {
    text: 'Common.description',
    value: 'description',
    presentWith: noHtmlTagsFormat,
  },
  {
    text: 'Dashboard.widgets.myTasks.headers.maturityDate',
    value: 'maturityDate',
    presentWith: dateFormatter.formatDateToLocaleDateStringNoTime,
  },
  // { text: 'Common.createdBy', value: 'createdByUserName' },
  // {
  //   text: 'Common.createdAt',
  //   value: 'createdAt',
  //   presentWith: dateFormatter.formatDateToLocaleDateStringNoTime,
  // },
];

const REPORT_WIDGETS = Object.freeze({
  // TODO: move to 3H replacements
  COMMISSION_REPORT_WIDGETS: [
    {
      id: 'commissionsByEmployee',
      moduleId: 'commissionReport',
      path: 'commissions',
      type: 'CHART',
      defaultChartType: 'DOUGHNUT',
      getData: response => ({ items: response.data.data }),
      metric: 'points',
      metricLabel: 'Punkte',
      legendLabel: 'employee',
      suffix: 'points',
      mapSuffix: points => `${points} ${points == 1 ? 'Punkt' : 'Punkte'}`,
      defaultFilter: {
        groupByEmployee: true,
        sort: 'points:desc',
        threshold: "0.05"
      },
      mapAdditionalFilters: filters => {
        if (!filters)
          return {};

        if (filters.fromDate && filters.untilDate)
          return { date: `${filters.fromDate},${filters.untilDate}` }

        if (filters.fromDate)
          return { date: filters.fromDate }

        if (filters.untilDate)
          return { date: filters.untilDate }

        return {};
      },
      xAxisLabel: 'Mitarbeiter',
      yAxisLabel: 'Punkte',
    }
  ],
  ABSENT_REPORT_WIDGETS: [
    {
      id: 'absentReport',
      path: 'reports/absentevaluation',
      headers: [
        {
          text: 'Dashboard.widgets.absentReport.headers.day',
          value: 'day'
        },
        { text: 'Common.employee', value: 'employee' },
        {
          text: 'Dashboard.widgets.absentReport.headers.personnelNumber',
          value: 'personnelNumber',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 30
        },
        {
          text: 'Common.type',
          value: 'attendanceType'
        },
        {
          text: 'Dashboard.widgets.absentReport.headers.workingHoursSum',
          value: 'workingHoursSum'
        },
        {
          text: 'Dashboard.widgets.absentReport.headers.department',
          value: 'department'
        },
        { text: 'Dashboard.widgets.absentReport.headers.group', value: 'group' }
      ],
      type: 'TABLE',
      moduleId: 'absentReport',
      withRouterActionLink: false
    }
  ],
  ANNIVERSARY_REPORT_WIDGETS: [
    {
      id: 'anniversary',
      path: 'reports/anniversaryreport',
      defaultFilter: {
        fromDate: FIRST_DAY_OF_CURRENT_YEAR,
        untilDate: LAST_DAY_OF_CURRENT_YEAR,
      },
      headers: [
        { text: 'Common.type', value: 'type' },
        { text: 'Dashboard.widgets.anniversary.headers.jubilee', value: 'round' },
        { text: 'Dashboard.widgets.anniversary.headers.person', value: 'person' },
        {
          text: 'Common.date',
          value: 'date',
          presentWith: dateFormatter.formatDateToLocaleDateStringNoTime
        }
      ],
      type: 'TABLE',
      moduleId: 'anniversary',
      withRouterActionLink: false
    }
  ],
  EMPLOYEE_REPORT_WIDGETS: [
    {
      id: 'employeeReport',
      path: 'reports/monthly-hours',
      headers: [
        {
          text: 'Dashboard.widgets.employeeReport.headers.projectNumber',
          value: 'projectNumber'
        },
        { text: 'Common.employee', value: 'employee' },
        {
          text: 'Dashboard.widgets.employeeReport.headers.personnelNumber',
          value: 'personnelNumber',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 30
        },
        {
          text: 'Dashboard.widgets.employeeReport.headers.department',
          value: 'department'
        },
        {
          text: 'Dashboard.widgets.employeeReport.headers.occupationGroup',
          value: 'occupationGroup',
          type: FORMAT_EXCEL_EXPORT_TYPE_ENUM.NUMBER,
          format: '0',
        },
        {
          text: 'Dashboard.widgets.employeeReport.headers.productive',
          value: 'productive',
          presentWith: formatBool
        },
        {
          text: 'Dashboard.widgets.employeeReport.headers.workingTime',
          value: 'workingTime'
        }
      ],
      type: 'TABLE',
      moduleId: 'employeeReport',
      withRouterActionLink: false
    }
  ],
  OCC_REPORT_WIDGETS: [
    {
      id: 'occReport',
      path: 'reports/monthly-occ-group',
      defaultFilter: {
        from: new Date().getFullYear() + '-01-01',
        until: new Date().getFullYear() + '-12-31',
      },
      headers: [
        { text: 'Dashboard.widgets.occReport.headers.hours', value: 'hours' },
        { text: 'Common.label', value: 'label' },
        {
          text: 'Dashboard.widgets.occReport.headers.isProductive',
          value: 'isProductive',
          presentWith: formatBool
        }
      ],
      type: 'TABLE',
      moduleId: 'occGroupReport',
      withRouterActionLink: false
    }
  ],
  PROJECT_BUDGET_REPORT_WIDGET: [
    {
      id: 'projectBudgetReport',
      path: 'reports/project-budget',
      headers: [
        { text: 'Common.label', value: 'label' },
        { text: 'Common.company', value: 'companyName' },
        { text: 'Common.status', value: 'status' },
        {
          text: 'Common.start',
          value: 'startDate',
          presentWith: dateFormatter.formatDateToLocaleDateStringNoTime
        },
        {
          text: 'Common.end',
          value: 'endDate',
          presentWith: dateFormatter.formatDateToLocaleDateStringNoTime
        },
        {
          text: 'Dashboard.widgets.projectBudgetReport.headers.isProductive',
          value: 'isProductive',
          presentWith: formatBool
        }
      ],
      type: 'TABLE',
      moduleId: 'projectBudgetReport',
      withRouterActionLink: true
    }
  ],
  REPORT_STOCK_WIDGETS: [
    {
      id: 'productView',
      path: 'reports/stock',
      headers: [
        { text: 'Common.matchcode', value: 'productMatchCode' },
        { text: 'Common.product', value: 'product' },
        {
          text: 'Dashboard.widgets.productView.headers.deviceSerialNumber',
          value: 'deviceSerialNumber'
        },
        { text: 'Common.amount', value: 'amount' },
        {
          text: 'Dashboard.widgets.productView.headers.productUnit',
          value: 'productUnit'
        },
        {
          text: 'Dashboard.widgets.productView.headers.productUnitSymbol',
          value: 'productUnitSymbol'
        },
        {
          text: 'Common.storageElement',
          value: 'storageElement'
        }
      ],
      type: 'TABLE',
      moduleId: 'stockReport',
      withRouterActionLink: false
    }
  ],
  SALE_STATISTICS_REPORT: [
    {
      id: 'saleStatisticView',
      path: 'reports/sales-statistics',
      headers: [
        { text: 'Common.customer', value: 'customer' },
        { text: 'Common.project', value: 'project' },
        {
          text: 'Dashboard.widgets.saleStatisticView.headers.projectType',
          value: 'projectType'
        },
        { text: 'Common.net', value: 'netAmount', presentWith: presentNumberToCurrencyTable },
        {
          text: 'Common.gross',
          value: 'grossAmount',
          presentWith: presentNumberToCurrencyTable,
          alignValue: 'right',
        },
      ],
      type: 'TABLE',
      moduleId: 'salesStatisticsReport',
      withRouterActionLink: false,
      defaultFilter: {
        accountingMode: "sales",
        customergroup: true
      }
    },
    {
      id: 'topCustomers',
      moduleId: 'salesStatisticsReport',
      path: 'reports/sales-statistics',
      type: 'CHART',
      getData: response => ({ items: response.data.data }),
      defaultChartType: 'PIE',
      metric: 'netAmount',
      legendLabel: 'customer',
      mapSuffix: presentNumberToCurrencyTable,
      suffix: 'netAmount',
      defaultFilter: {
        accountingMode: "sales",
        customergroup: true,
        sort: 'netAmount:desc',
        size: 10,
      },
      xAxisLabel: 'Kunde',
      yAxisLabel: 'Einnahmen [€]',
      hideLegend: true,
    },
    {
      id: 'saleStatisticNetCustomer',
      moduleId: 'salesStatisticsReport',
      path: 'reports/sales-statistics',
      type: 'CHART',
      getData: response => ({ items: response.data.data }),
      defaultChartType: 'PIE',
      metric: 'netAmount',
      legendLabel: 'customer',
      mapSuffix: presentNumberToCurrencyTable,
      suffix: 'netAmount',
      defaultFilter: {
        accountingMode: "sales",
        customergroup: true,
        size: 100,
      },
      xAxisLabel: 'Kunde',
      yAxisLabel: 'Einnahmen [€]',
      hideLegend: true,
    },
    {
      id: 'saleStatisticGross',
      moduleId: 'salesStatisticsReport',
      path: 'reports/sales-statistics',
      type: 'CHART',
      getData: response => ({ items: response.data.data }),
      defaultChartType: 'PIE',
      metric: 'grossAmount',
      legendLabel: 'customer',
      mapSuffix: presentNumberToCurrencyTable,
      suffix: 'grossAmount',
      defaultFilter: {
        accountingMode: "sales",
        customergroup: true
      }
    },
  ],
  PROJECT_REPORT_WIDGETS: [
    {
      id: 'projectStartByType',
      moduleId: 'projectReport',
      path: 'reports/projectreport',
      type: 'CHART',
      getData: response => ({ items: response.data.data }),
      defaultChartType: 'LINE',
      metric: 'projectCount',
      legendLabel: 'month',
      suffix: 'projectCount',
      mapSuffix: projectCount => `${projectCount} ${projectCount == 1 ? 'Projekt' : 'Projekte'}`,
      labelMapper: item => {
        const [year, month] = item.data?.month?.split('-') ?? item.month?.split('-');
        const monthName = i18n.t(`Months.asNumber.${parseInt(month)}`);
        return `${monthName} ${year}`;
      },
      datasetGrouping: 'projectType',
      defaultFilter: {
        groupByMonth: true,
        groupByProjectType: true,
        size: 500
      },
      mapAdditionalFilters: filters => {
        if (!filters)
          return {};

        return {
          from: filters.fromDate,
          until: filters.untilDate,
        }
      },
      xAxisLabel: 'Monat',
      yAxisLabel: 'Anzahl Projekte',
    },
  ],
  TASK_REPORT_WIDGETS: [
    {
      id: 'taskReport',
      moduleId: 'tasks',
      path: 'reports/taskreport',
      type: 'CHART',
      getData: response => ({ items: response.data.data }),
      headers: [
        { text: 'Status', value: 'status' },
        { text: 'Anzahl', value: 'anzahl' },
      ],
      defaultChartType: 'DOUGHNUT',
      metric: 'anzahl',
      metricLabel: 'Aufgaben',
      legendLabel: 'status',
      suffix: 'anzahl',
      mapSuffix: tasks  => `${tasks} ${tasks == 1 ? 'Aufgabe' : 'Aufgaben'}`,
      defaultFilter: {
        groupByStatus: true,
      }
    },
    {
      id: 'myTasks',
      moduleId: 'tasks',
      path: 'tasks',
      type: 'TABLE',
      getData: response => response.data.data?.map(item => item.data),
      headers: TASK_TABLE_HEADERS,
      withRouterActionLink: true,
      mapAdditionalFilters: () => ({
        user: store.state.actingUser.actingUserDetails.userId,
      }),
      defaultFilter: {
        status: 'OPEN'
      }
    },
  ]
});

export default REPORT_WIDGETS;
